class BlurSection extends HTMLElement {
    constructor() {
        super();
        this.content = this.querySelector('.blur-content-section');
        this.handleIntersection = this.handleIntersection.bind(this);
        this.backgroundImage = this.querySelector('.blur-background-container');
        this.animateOnScroll = this.animateOnScroll.bind(this);
    }

    connectedCallback() {
        this.intersectionOptions = {
            root: null,
            rootMargin: '0% 0% -50% 0%',
            threshold: 0
        }

        this.observer = new IntersectionObserver(
            this.handleIntersection,
            this.intersectionOptions
        );

        this.observer.observe(this.content);
    }

    handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                window.addEventListener('scroll', this.animateOnScroll);
            } else {
                window.removeEventListener('scroll', this.animateOnScroll);
            }
        })
    }

    animateOnScroll() {

        window.requestAnimationFrame(() => {
            const scaleRatio = (this.closest('div').offsetTop + this.content.offsetTop) / window.scrollY;
            this.backgroundImage.style.transform = `scale(${scaleRatio})`
        })
    }
}

customElements.define('blur-section', BlurSection);
